import { WatchlistActionType, WatchlistSummaryType } from '@apply/constants';
import { watchlistActions, loanActions } from '@apply/adminStore';

export const executeWatchlistAction = (itemData, dispatch, summaryTypeId: WatchlistSummaryType) => {
    const onModify = (watchlistId: number, loanId: number, propertyId: number) => {
        dispatch(
            watchlistActions.setWatchlistLoanDetailModal({
                watchlistLoanDetailModal: { isOpen: true, watchlistId, loanId, propertyId },
            })
        );
    };

    const onLoanDetails = (loanId: number) => {
        dispatch(
            loanActions.setEditStdLoanModal({
                editStdLoanModal: {
                    isOpen: true,
                    loanId,
                    showInsurance: false,
                },
            })
        );
    };

    const onEditGroup = (watchlistId: number, groupId: number) => {
        dispatch(
            watchlistActions.setGroupItemsModal({
                groupItemsModal: {
                    isOpen: true,
                    watchlistId,
                    summaryTypeId,
                    groupId,
                },
            })
        );
    };

    const onLoanAuditHistory = (loanId: number) => {
        dispatch(
            loanActions.setAuditHistoryModal({
                auditHistoryModal: { isOpen: true, loanId },
            })
        );
    };

    const onNotImplemented = () => {
        alert('Not Implemented yet!');
    };

    switch (itemData.id) {
        case WatchlistActionType.WatchlistEntryDetails:
            onModify(itemData.watchlistId, itemData.loanId, itemData.propertyId);
            break;
        case WatchlistActionType.LoanDetails:
            onLoanDetails(itemData.loanId);
            break;
        case WatchlistActionType.WatchlistEditGroup:
            onEditGroup(itemData.watchlistId, itemData.groupId);
            break;
        case WatchlistActionType.LoanAuditHistory:
            onLoanAuditHistory(itemData.loanId);
            break;
        default:
            onNotImplemented();
            break;
    }
};
